<!-- 首页 -->
<template>
  <div class="company-portal">
    <!-- ===== HERO 轮播 ===== -->
    <section class="hero-section">
      <div class="hero-wrapper">
        <div
          class="hero-slides"
          :style="{ transform: `translateX(-${activeIndex * 100}%)` }"
        >
          <div
            class="hero-slide"
            v-for="(banner, index) in heroImages"
            :key="index"
            :style="{ backgroundImage: `url(${require('@/components/images/' + banner)})` }"
          >
            <div class="hero-overlay"></div>
            <div class="hero-content">
              <div class="hero-badge banner-animated" :class="{ 'is-active': activeIndex === index }">
                <span class="badge-dot"></span>
                <span>{{ banners[index].tag }}</span>
              </div>
              <h1 class="hero-title banner-animated" :class="{ 'is-active': activeIndex === index }" style="animation-delay: 0.1s">
                <span class="title-line" style="font-size: 0.53em;">{{ banners[index].titleLine1 }}</span>
                <span class="title-line title-line--highlight" style="font-size: 0.55em;">{{ banners[index].titleLine2 }}</span>
              </h1>
              <div class="hero-divider banner-animated" :class="{ 'is-active': activeIndex === index }" style="animation-delay: 0.22s">
                <span class="divider-line"></span>
                <span class="divider-diamond"></span>
              </div>
              <p class="hero-desc banner-animated" :class="{ 'is-active': activeIndex === index }" style="animation-delay: 0.3s" v-html="banners[index].desc"></p>
              <div class="hero-actions banner-animated" :class="{ 'is-active': activeIndex === index }" style="animation-delay: 0.4s">
                <button class="btn-primary" @click="scrollToContact">
                  <span>免费咨询</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                  </svg>
                </button>
                <button class="btn-outline" @click="scrollToServices">了解更多</button>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部条形指示器 -->
        <div class="hero-indicators">
          <span
            v-for="(banner, index) in heroImages"
            :key="index"
            class="hero-indicator"
            :class="{ 'is-active': activeIndex === index }"
            @click="activeIndex = index"
          ></span>
        </div>
      </div>
    </section>

    <!-- ===== 公司简介 ===== -->
    <section class="about-section" id="about">
      <div class="container">
        <div class="about-grid">
          <div class="about-image">
            <img :src="require('@/components/images/宣传图首页.png')" alt="科曼驰汽车修复" />
          </div>
          <div class="about-content">
            <div class="section-tag">ABOUT KOMANCH</div>
            <h2 class="section-title">科曼驰 · 高端汽车修复专家</h2>
            <p class="about-text">
              北京科曼驰汽车服务有限公司专注汽车无痕凹陷修复（PDR）、挡风玻璃微创修复以及局部点漆服务。我们采用德国技术工艺，保留原厂漆面，让爱车价值最大化。
            </p>
            <p class="about-text">
              拥有多年宾利、保时捷、奔驰、宝马等高端车修复经验，是京城众多车主信赖的汽车美容修复专家。
            </p>
            <div class="about-features">
              <div class="about-feature">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <span>德国技术工艺</span>
              </div>
              <div class="about-feature">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                <span>原厂漆面保留</span>
              </div>
              <div class="about-feature">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <polyline points="12 6 12 12 16 14"/>
                </svg>
                <span>一小时快修</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 核心服务 ===== -->
    <section class="services-section" id="services">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">OUR SERVICES</span>
          <h2 class="section-title">三大核心修复服务</h2>
          <p class="section-subtitle">专业 · 高效 · 原厂漆守护</p>
        </div>
        <div class="services-grid">
          <div class="service-card featured">
            <div class="service-icon">
              <img :src="require('@/components/images/科曼驰项目-凹陷修复.png')" alt="凹陷修复" />
            </div>
            <p>专业PDR工具从内部精准顶推，恢复车身弧线。冰雹坑、车门凹痕、停车磕碰，不动钣金不伤漆。</p>
            <router-link to="/product" class="service-link">了解详情 →</router-link>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <img :src="require('@/components/images/科曼驰项目-玻璃修复.png')" alt="玻璃修复" />
            </div>
            <p>牛眼裂纹、星状破损，进口树脂高压注胶，紫外线固化后强度接近原厂，避免高额换玻璃费用。</p>
            <router-link to="/product" class="service-link">了解详情 →</router-link>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <img :src="require('@/components/images/科曼驰项目-局部点漆.png')" alt="局部点漆" />
            </div>
            <p>小面积划痕、掉漆精准点补，电脑调色匹配原车漆，修复后几乎无色差，经济快捷。</p>
            <router-link to="/product" class="service-link">了解详情 →</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 核心优势 ===== -->
    <section class="advantages-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">WHY CHOOSE US</span>
          <h2 class="section-title">为什么选择科曼驰</h2>
          <p class="section-subtitle">品质 · 细节 · 信任</p>
        </div>
        <div class="advantages-grid">
          <div class="advantage-item">
            <div class="advantage-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            <h4>原厂漆保留</h4>
            <p>拒绝钣金喷漆，保留原始漆面质感与厚度，车辆保值。</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <h4>一小时快修</h4>
            <p>多数凹陷1小时内完成，即修即走，告别漫长等待。</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <path d="M2 20h20"/>
                <path d="M4 17l2-9 4 5 2-7 2 7 4-5 2 9"/>
                <circle cx="12" cy="4" r="1"/>
              </svg>
            </div>
            <h4>高端车专修</h4>
            <p>宾利/保时捷/奔驰/宝马等数千台案例，技术精湛。</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5">
                <rect x="1" y="3" width="15" height="13" rx="2"/>
                <polyline points="16 8 20 8 23 11 23 16 16 16 16 8"/>
              </svg>
            </div>
            <h4>上门服务</h4>
            <p>北京全域移动服务车，快速响应，提供两年质保。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 资质荣誉 ===== -->
    <section class="cert-section" v-if="certList.length > 0">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">CERTIFICATES</span>
          <h2 class="section-title">资质荣誉</h2>
          <p class="section-subtitle">专业认证 · 技术实力 · 品牌保障</p>
        </div>
        <div class="cert-carousel" @mouseenter="stopCertAutoplay" @mouseleave="startCertAutoplay">
          <!-- 左箭头 -->
          <button class="cert-nav cert-nav-prev" @click="prevCertSlide" v-if="certList.length > 4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <!-- 右箭头 -->
          <button class="cert-nav cert-nav-next" @click="nextCertSlide" v-if="certList.length > 4">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
          <div class="cert-track" :style="{ transform: `translateX(-${certOffset * 264}px)` }">
            <div
              v-for="(cert, index) in certList"
              :key="cert.id"
              class="cert-item"
              @click="openLightbox(index)"
            >
              <div class="cert-img-wrap">
                <img :src="cert.img ? '' + cert.img : ''" :alt="cert.title" class="cert-img" v-if="cert.img" />
                <div class="cert-zoom">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    <line x1="11" y1="8" x2="11" y2="14"/>
                    <line x1="8" y1="11" x2="14" y2="11"/>
                  </svg>
                </div>
              </div>
              <p class="cert-title">{{ cert.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 大图预览 -->
    <div class="lightbox" :class="{ open: lightboxOpen }" @click="closeLightbox">
      <button class="lightbox-close" @click="closeLightbox">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
      <button class="lightbox-prev" @click.stop="prevCert">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>
      <div class="lightbox-content" @click.stop v-if="certList[lightboxIndex]?.img">
        <img :src="'' + certList[lightboxIndex]?.img" :alt="certList[lightboxIndex]?.title" class="lightbox-img" />
      </div>
      <button class="lightbox-next" @click.stop="nextCert">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <p class="lightbox-caption">{{ certList[lightboxIndex]?.title }}</p>
    </div>

    <!-- ===== 联系方式 ===== -->
    <section class="contact-section" id="contact">
      <div class="container">
        <div class="contact-wrapper">
          <div class="contact-info">
            <span class="section-tag" style="color: #d4af37;">CONTACT US</span>
            <h2>联系我们</h2>
            <p class="contact-desc">科曼驰团队为您提供免费凹陷评估及修复方案</p>
            <div class="contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
              <div>
                <h4>服务热线</h4>
                <p>159-3133-4385</p>
              </div>
            </div>
            <div class="contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
              <div>
                <h4>电子邮箱</h4>
                <p>komanchpdr@gmail.com</p>
              </div>
            </div>
            <div class="contact-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              <div>
                <h4>服务中心地址</h4>
                <p>朝阳区金港汽车公园A座 · 科曼驰无痕修复中心</p>
              </div>
            </div>
          </div>
          <div class="contact-form">
            <div class="form-header">
              <span class="section-tag" style="margin-bottom: 8px;">BOOK NOW</span>
              <h3 class="form-title">免费评估预约</h3>
              <p class="form-desc">填写下方表单，我们将在24小时内与您联系。</p>
            </div>
            <form @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group">
                  <label>您的姓名 <span class="required">*</span></label>
                  <input v-model="form.name" type="text" placeholder="请输入姓名" required maxlength="20" />
                  <span class="char-count">{{ form.name.length }}/20</span>
                </div>
                <div class="form-group">
                  <label>联系电话 <span class="required">*</span></label>
                  <input
                    v-model="form.phone"
                    type="tel"
                    placeholder="请输入手机号"
                    maxlength="11"
                    required
                    @input="form.phone = form.phone.replace(/\D/g, '').slice(0, 11)"
                    @blur="form.phone = form.phone.replace(/\D/g, '').slice(0, 11)"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>服务类型 <span class="required">*</span></label>
                <select v-model="form.service" required>
                  <option value="" disabled>请选择服务类型</option>
                  <option :value="1">无痕凹陷修复</option>
                  <option :value="2">挡风玻璃修复</option>
                  <option :value="3">局部点漆</option>
                  <option :value="4">其他咨询</option>
                </select>
              </div>
              <div class="form-group">
                <label>车辆信息</label>
                <input v-model="form.carInfo" type="text" placeholder="车型、年份（如：奔驰C级 2026款）" maxlength="50" />
              </div>
              <div class="form-group">
                <label>问题描述</label>
                <textarea v-model="form.message" rows="3" placeholder="请描述您的车辆损伤情况（凹陷位置、大小等）" maxlength="300"></textarea>
                <span class="char-count">{{ form.message.length }}/300</span>
              </div>
              <!-- 反垃圾：隐藏字段，机器人会填充，正常用户看不到 -->
              <div class="form-group form-honeypot" aria-hidden="true">
                <input v-model="form.honeypot" tabindex="-1" autocomplete="off" />
              </div>
              <!-- 验证码 -->
              <div class="form-group form-captcha">
                <label>验证码 <span class="required">*</span></label>
                <input v-model.number="form.captcha" type="number" placeholder="请输入计算结果" required />
                <button class="captcha-btn" @click="refreshCaptcha" :disabled="countdown > 0">
                  {{ captchaQuestion || '加载中…' }}
                </button>
              </div>
              <button type="submit" class="btn-submit" :disabled="submitting || countdown > 0">
                <span v-if="submitting">提交中…</span>
                <span v-else-if="countdown > 0">{{ countdown }} 秒后可重试</span>
                <span v-else>提交预约</span>
              </button>
              <p v-if="formMsg" :class="['form-msg', formSuccess ? 'success' : 'error']">{{ formMsg }}</p>
            </form>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import axios from 'axios'

// 轮播图数据
const heroImages = ['首页展示1.png', '首页展示2.png']
const banners = ref([
  {
    tag: '德国 PDR 技术 · 原厂漆守护',
    titleLine1: '无痕修复',
    titleLine2: '重塑匠心之美',
    desc: '保留原厂漆面 · 一小时焕新 · 高端车专修'
  },
  {
    tag: '专业 · 高效 · 原厂漆守护',
    titleLine1: '科曼驰',
    titleLine2: '京城车主信赖之选',
    desc: '冰雹坑 · 车门凹痕 · 停车磕碰<br>不动钣金不伤漆，原厂漆价值最大化'
  }
])

const activeIndex = ref(0)
let heroTimer = null

const startHeroAutoplay = () => {
  heroTimer = setInterval(() => {
    activeIndex.value = (activeIndex.value + 1) % heroImages.length
  }, 5000)
}

const stopHeroAutoplay = () => {
  if (heroTimer) {
    clearInterval(heroTimer)
    heroTimer = null
  }
}

// 资质荣誉数据
const certList = ref([])

// 从 API 加载荣誉证书
const loadCertList = async () => {
  try {
    const res = await axios.get('/webapi/cert/list')
    if (res.data.ActionType === 'OK' && res.data.data) {
      certList.value = res.data.data.map((cert, index) => ({
        id: cert._id || index,
        img: cert.img,
        title: cert.title
      }))
    }
  } catch (e) {
    // API 失败时使用默认静态数据
    certList.value = [
    ]
  }
}

const lightboxOpen = ref(false)
const lightboxIndex = ref(0)
const certOffset = ref(0)
let certTimer = null

// 计算当前可见的证书（每次显示4个）
const visibleCerts = computed(() => {
  if (certList.value.length <= 4) return certList.value
  const total = certList.value.length
  return Array.from({ length: 4 }, (_, i) => certList.value[(certOffset.value + i) % total])
})

// 自动轮播
const startCertAutoplay = () => {
  certTimer = setInterval(() => {
    certOffset.value = (certOffset.value + 1) % certList.value.length
  }, 3000)
}

const stopCertAutoplay = () => {
  if (certTimer) {
    clearInterval(certTimer)
    certTimer = null
  }
}

const openLightbox = (index) => {
  lightboxIndex.value = index % certList.value.length
  lightboxOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeLightbox = () => {
  lightboxOpen.value = false
  document.body.style.overflow = ''
}

const prevCert = () => {
  lightboxIndex.value = (lightboxIndex.value - 1 + certList.value.length) % certList.value.length
}

const nextCert = () => {
  lightboxIndex.value = (lightboxIndex.value + 1) % certList.value.length
}

// 轮播导航
const prevCertSlide = () => {
  certOffset.value = (certOffset.value - 1 + certList.value.length) % certList.value.length
  stopCertAutoplay()
  startCertAutoplay()
}

const nextCertSlide = () => {
  certOffset.value = (certOffset.value + 1) % certList.value.length
  stopCertAutoplay()
  startCertAutoplay()
}

// 键盘事件
const handleKeydown = (e) => {
  if (!lightboxOpen.value) return
  if (e.key === 'ArrowLeft') prevCert()
  else if (e.key === 'ArrowRight') nextCert()
  else if (e.key === 'Escape') closeLightbox()
}

onMounted(async () => {
  window.addEventListener('keydown', handleKeydown)
  generateCaptcha()
  await loadCertList()
  startHeroAutoplay()
  if (certList.value.length > 4) {
    startCertAutoplay()
  }
})
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown)
  if (countdownTimer) clearInterval(countdownTimer)
  stopCertAutoplay()
  stopHeroAutoplay()
  // 清理 body overflow，防止页面切换后样式异常
  document.body.style.overflow = ''
})

// 滚动到对应区域
const scrollToContact = () => {
  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })
}

const scrollToServices = () => {
  document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' })
}

// 表单相关
const form = ref({ name: '', phone: '', service: '', carInfo: '', message: '', honeypot: '', captcha: null })
const submitting = ref(false)
const formMsg = ref('')
const formSuccess = ref(false)
const captchaQuestion = ref('')
const captchaAnswer = ref(0)
const countdown = ref(0)

let countdownTimer = null

// 生成简单加减法验证码
const generateCaptcha = () => {
  const ops = ['+', '-']
  const op = ops[Math.floor(Math.random() * ops.length)]
  let a, b, answer
  if (op === '+') {
    a = Math.floor(Math.random() * 20) + 1
    b = Math.floor(Math.random() * 20) + 1
    answer = a + b
  } else {
    a = Math.floor(Math.random() * 20) + 5
    b = Math.floor(Math.random() * a)
    answer = a - b
  }
  captchaQuestion.value = `${a} ${op} ${b} = ?`
  captchaAnswer.value = answer
}

const refreshCaptcha = () => {
  generateCaptcha()
}

const startCountdown = () => {
  countdown.value = 60
  countdownTimer = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(countdownTimer)
      countdownTimer = null
    }
  }, 1000)
}

const submitForm = async () => {
  formMsg.value = ''
  formSuccess.value = false

  if (!form.value.name || !form.value.phone || !form.value.service) {
    formMsg.value = '请填写必要信息'
    formSuccess.value = false
    return
  }
  if (form.value.name.length > 20) {
    formMsg.value = '姓名不能超过20个字'
    formSuccess.value = false
    return
  }
  if (!/^1[3-9]\d{9}$/.test(form.value.phone)) {
    formMsg.value = '请输入正确的手机号码'
    formSuccess.value = false
    return
  }
  if (form.value.message.length > 300) {
    formMsg.value = '问题描述不能超过300个字'
    formSuccess.value = false
    return
  }
  if (form.value.honeypot && form.value.honeypot !== '') {
    return
  }
  if (form.value.captcha === undefined || form.value.captcha === null) {
    formMsg.value = '请输入验证码'
    formSuccess.value = false
    return
  }
  if (form.value.captcha !== captchaAnswer.value) {
    formMsg.value = '验证码错误，请重试'
    formSuccess.value = false
    refreshCaptcha()
    return
  }

  submitting.value = true
  try {
    const submitPayload = {
      name: form.value.name,
      phone: form.value.phone,
      service: form.value.service,
      carDesc: [form.value.carInfo, form.value.message].filter(Boolean).join(' | '),
      _ts: Date.now(),
      captcha: form.value.captcha,
    }
    const res = await axios.post('/webapi/apply/submit', submitPayload)
    if (res.data.ActionType === 'OK') {
      formMsg.value = '提交成功！我们将在24小时内与您联系。'
      formSuccess.value = true
      form.value = { name: '', phone: '', service: '', carInfo: '', message: '', honeypot: '', captcha: null }
      startCountdown()
      refreshCaptcha()
    } else {
      formMsg.value = res.data.error || '提交失败，请稍后重试'
      formSuccess.value = false
      refreshCaptcha()
    }
  } catch (e) {
    formMsg.value = '网络错误，请稍后重试'
    formSuccess.value = false
    refreshCaptcha()
  } finally {
    submitting.value = false
  }
}

</script>

<style scoped lang="scss">
// ===== 变量 =====
$gold: #d4af37;
$gold-light: #f0e4c8;
$dark: #1a1a1a;
$gray: #6b7280;
$light-gray: #f8f9fa;
$border: #e5e7eb;

// ===== 轮播动画 =====

// 主入场：向上滑出 + 淡入，克制而优雅
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(28px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

// 分割线绘制
@keyframes lineGrow {
  0% { width: 0; opacity: 0; }
  60% { opacity: 1; }
  100% { width: 100%; opacity: 1; }
}

// 菱形弹出
@keyframes diamondPop {
  0% { transform: rotate(45deg) scale(0); opacity: 0; }
  70% { transform: rotate(45deg) scale(1.15); opacity: 1; }
  100% { transform: rotate(45deg) scale(1); opacity: 1; }
}

// 徽章光晕
@keyframes badgePulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.35); }
  50% { box-shadow: 0 0 0 10px rgba(212, 175, 55, 0); }
}

// 基础状态
.banner-animated {
  opacity: 0;
}

.banner-animated.is-active {
  animation: fadeInUp 0.85s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

// 徽章
.hero-badge.is-active {
  animation: fadeInUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.05s forwards;
}

.hero-badge.is-active span:first-child {
  animation: badgePulse 2.5s ease-in-out infinite 1s;
}

// 标题
.hero-title.is-active {
  animation: fadeInUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.12s forwards;
}

.hero-title .title-line {
  display: block;
  position: relative;
}

// 第二行高亮：纯金色 + 发光效果
.hero-title .title-line--highlight {
  color: #d4af37;
  text-shadow: 0 0 20px rgba(212, 175, 55, 0.5), 0 0 40px rgba(212, 175, 55, 0.2);
  animation: goldPulse 3s ease-in-out infinite;
}

@keyframes goldPulse {
  0%, 100% { text-shadow: 0 0 20px rgba(212, 175, 55, 0.5), 0 0 40px rgba(212, 175, 55, 0.2); }
  50% { text-shadow: 0 0 30px rgba(212, 175, 55, 0.8), 0 0 60px rgba(212, 175, 55, 0.3); }
}

// 分割线
.hero-divider.is-active {
  animation: fadeInUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.35s forwards;
}

.divider-line {
  display: block;
  height: 1px;
  width: 0;
  background: linear-gradient(90deg, $gold, rgba(212,175,55,0.15), transparent);
}

.hero-divider.is-active .divider-line {
  animation: lineGrow 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.45s forwards;
}

.divider-diamond {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: $gold;
  transform: rotate(45deg);
  margin: 0 10px;
  opacity: 0;
}

.hero-divider.is-active .divider-diamond {
  animation: diamondPop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.85s forwards;
}

// 描述
.hero-desc.is-active {
  animation: fadeInUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
}

// 按钮
.hero-actions.is-active {
  animation: fadeInUp 0.65s cubic-bezier(0.22, 1, 0.36, 1) 0.6s forwards;
}


// ===== 全局 =====
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

// ===== Hero 轮播 =====
.hero-section {
  position: relative;
  margin-top: 72px;
  height: 100vh;
  overflow: hidden;

  .hero-wrapper {
    position: relative;
    height: 100%;
  }

  .hero-slides {
    display: flex;
    height: 100%;
    transition: transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  }

  .hero-slide {
    position: relative;
    min-width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;

    .hero-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.2) 100%);
    }

    .hero-content {
      position: relative;
      z-index: 2;
      max-width: 700px;
      color: #fff;
      padding: 0 24px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .hero-badge {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 5px 16px;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 2px;
        color: $gold;
        background: rgba(212, 175, 55, 0.12);
        border: 1px solid rgba(212, 175, 55, 0.35);
        border-radius: 20px;
        margin-bottom: 28px;

        .badge-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: $gold;
          flex-shrink: 0;
        }
      }

      .hero-title {
        font-size: 80px;
        font-weight: 800;
        line-height: 1.1;
        margin-bottom: 20px;
        letter-spacing: -1px;
        color: #fff;

        .title-line {
          display: block;
        }

        .title-line--highlight {
          position: relative;
        }
      }

      .hero-divider {
        margin-bottom: 24px;
        height: 1px;
        display: flex;
        align-items: center;

        .divider-line {
          flex: 1;
          height: 1px;
        }
      }

      .hero-desc {
        font-size: 17px;
        line-height: 1.8;
        color: rgba(255, 255, 255, 0.75);
        margin-bottom: 36px;
      }

      .hero-actions {
        display: flex;
        gap: 16px;
        margin-bottom: 48px;

        .btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 32px;
          font-size: 15px;
          font-weight: 600;
          color: #fff;
          background: $gold;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.35s ease;
          position: relative;
          overflow: hidden;

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
            transition: left 0.5s ease;
          }

          &:hover::before {
            left: 100%;
          }

          &:hover {
            background: #c4a030;
            transform: translateY(-2px);
            box-shadow: 0 12px 32px rgba(212, 175, 55, 0.3);
          }
        }

        .btn-outline {
          padding: 14px 32px;
          font-size: 15px;
          font-weight: 600;
          color: #fff;
          background: transparent;
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.35s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.08);
            border-color: rgba(255, 255, 255, 0.7);
            transform: translateY(-2px);
          }
        }
      }
    }
  }

  .hero-indicators {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    z-index: 3;

    .hero-indicator {
      width: 40px;
      height: 3px;
      background: rgba(255, 255, 255, 0.35);
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.35s ease;

      &.is-active {
        background: $gold;
        width: 56px;
      }

      &:hover:not(.is-active) {
        background: rgba(255, 255, 255, 0.6);
      }
    }
  }
}

// ===== 按钮 =====
.btn-primary {
  padding: 14px 40px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: $dark;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #333;
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  }
}

.btn-outline {
  padding: 14px 40px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: #fff;
    transform: translateY(-2px);
  }
}

// ===== 通用 Section =====
.section-tag {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: $gold;
  display: block;
  margin-bottom: 12px;
}

.section-title {
  font-size: 36px;
  font-weight: 800;
  color: $dark;
  margin: 8px 0 12px;
}

.section-subtitle {
  font-size: 16px;
  color: $gray;
}

.section-header {
  text-align: center;
  margin-bottom: 56px;
}

// ===== About =====
.about-section {
  padding: 80px 0;
  background: #fff;

  .about-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
  }

  .about-image {
    position: relative;
    border-radius: 16px;
    overflow: hidden;

    img {
      width: 100%;
      height: 420px;
      object-fit: cover;
    }

    .image-badge {
      position: absolute;
      bottom: 24px;
      left: 24px;
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 16px 24px;
      background: rgba(0, 0, 0, 0.8);
      backdrop-filter: blur(8px);
      border-radius: 12px;

      .badge-number {
        font-size: 28px;
        font-weight: 700;
        color: $gold;
      }

      .badge-text {
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .about-content {
    .about-text {
      font-size: 15px;
      line-height: 1.8;
      color: $gray;
      margin-bottom: 16px;
    }

    .about-features {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      margin-top: 32px;

      .about-feature {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        padding: 16px;
        background: $light-gray;
        border-radius: 12px;

        span {
          font-size: 13px;
          font-weight: 500;
          color: $dark;
        }
      }
    }
  }
}

// ===== Services =====
.services-section {
  padding: 80px 0;
  background: $light-gray;

  .services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  .service-card {
    padding: 40px 32px;
    background: #fff;
    border-radius: 16px;
    text-align: center;
    transition: all 0.4s ease;
    border: 1px solid $border;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 48px rgba(0, 0, 0, 0.08);
    }

    &.featured {
      border-color: $gold;
      position: relative;
      &::before {
        content: '推荐';
        position: absolute;
        top: -10px;
        right: 24px;
        padding: 4px 16px;
        font-size: 11px;
        font-weight: 600;
        color: #fff;
        background: $gold;
        border-radius: 20px;
      }
    }

    .service-icon {
      margin-bottom: 20px;
      img {
        width: 280px;
        height: 280px;
        object-fit: contain;
        border-radius: 20px;
        box-shadow: 0 4px 16px rgba(0,0,0,0.1);
      }
    }

    h3 {
      font-size: 20px;
      font-weight: 700;
      color: $dark;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      line-height: 1.7;
      color: $gray;
      margin-bottom: 20px;
    }

    .service-link {
      font-size: 14px;
      font-weight: 500;
      color: $gold;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        color: $dark;
      }
    }
  }
}

// ===== Advantages =====
.advantages-section {
  padding: 80px 0;
  background: #fff;

  .advantages-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }

  .advantage-item {
    padding: 32px 24px;
    text-align: center;
    background: $light-gray;
    border-radius: 12px;
    transition: all 0.4s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.06);
    }

    .advantage-icon {
      margin-bottom: 16px;
    }

    h4 {
      font-size: 16px;
      font-weight: 600;
      color: $dark;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      color: $gray;
      line-height: 1.6;
    }
  }
}

// ===== 资质荣誉 =====
.cert-section {
  padding: 80px 0;
  background: $light-gray;

  .cert-carousel {
    overflow: hidden;
    position: relative;
    margin: 0 -12px;
    padding: 8px 0;

    // 轮播轨道
    .cert-track {
      display: flex;
      gap: 24px;
      transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
      padding: 0 12px;
    }

    // 导航按钮
    .cert-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.9);
      border: 1px solid $border;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $dark;
      transition: all 0.3s ease;
      z-index: 10;

      &:hover {
        background: $gold;
        color: #fff;
        border-color: $gold;
        box-shadow: 0 4px 12px rgba(212, 175, 55, 0.3);
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }

    .cert-nav-prev {
      left: 8px;
    }

    .cert-nav-next {
      right: 8px;
    }
  }

  .cert-item {
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    flex-shrink: 0;
    width: 240px;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 16px 40px rgba(0,0,0,0.1);

      .cert-img-wrap {
        .cert-zoom { opacity: 1; transform: translateY(0); }
      }
    }

    .cert-img-wrap {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      background: #fff;
      border: 1px solid $border;
      aspect-ratio: 3 / 4;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;

      .cert-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
      }

      .cert-zoom {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(26,26,26,0.6);
        color: #fff;
        opacity: 0;
        transform: translateY(8px);
        transition: all 0.3s ease;
      }
    }

    .cert-title {
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      color: $dark;
      margin-top: 12px;
      letter-spacing: 0.5px;
    }
  }
}

// ===== Lightbox =====
.lightbox {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.9);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }

  .lightbox-close {
    position: absolute;
    top: 24px;
    right: 24px;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255,255,255,0.2);
      transform: rotate(90deg);
    }
  }

  .lightbox-prev,
  .lightbox-next {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(212,175,55,0.3);
      border-color: $gold;
    }
  }

  .lightbox-prev { left: 24px; }
  .lightbox-next { right: 24px; }

  .lightbox-content {
    max-width: 85vw;
    max-height: 75vh;
    display: flex;
    align-items: center;
    justify-content: center;

    .lightbox-img {
      max-width: 100%;
      max-height: 75vh;
      object-fit: contain;
      border-radius: 8px;
      box-shadow: 0 24px 64px rgba(0,0,0,0.5);
      animation: lightboxZoomIn 0.35s cubic-bezier(0.16, 1, 0.3, 1);
    }
  }

  .lightbox-caption {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 600;
    color: rgba(255,255,255,0.8);
    letter-spacing: 1px;
  }
}

@keyframes lightboxZoomIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

// ===== Contact =====
.contact-section {
  padding: 80px 0;
  background: $dark;

  .contact-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: start;
  }

  .contact-info {
    color: #fff;

    h2 {
      font-size: 36px;
      font-weight: 700;
      margin: 8px 0 12px;
    }

    .contact-desc {
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
      margin-bottom: 32px;
    }

    .contact-item {
      display: flex;
      gap: 16px;
      margin-bottom: 24px;

      h4 {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 4px;
      }

      p {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }

  .contact-form {
    background: #fff;
    border-radius: 16px;
    padding: 36px;
    border: 1px solid $border;
    box-shadow: 0 4px 16px rgba(0,0,0,0.04);

    .form-header {
      margin-bottom: 28px;

      .form-title {
        font-size: 22px;
        font-weight: 700;
        color: $dark;
        margin-bottom: 6px;
      }

      .form-desc {
        font-size: 14px;
        color: $gray;
      }
    }

    .form-row {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;
      margin: 0 -8px;
    }

    .form-row .form-group {
      flex: 1;
      min-width: 200px;
      padding: 0 8px;
    }

    .form-group {
      display: flex;
      flex-direction: column;
      min-width: 0;
      width: 100%;
      margin-bottom: 18px;

      label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: $dark;
        margin-bottom: 6px;

        .required {
          color: #ff4d4f;
          margin-left: 2px;
        }
      }

      input, select, textarea {
        width: 100%;
        box-sizing: border-box;
        padding: 12px 16px;
        font-size: 14px;
        border: 1px solid $border;
        border-radius: 8px;
        transition: all 0.3s ease;
        background: #fff;
        color: $dark;
        font-family: inherit;

        &::placeholder { color: #bbb; }

        &:focus {
          outline: none;
          border-color: $gold;
          box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
        }
      }

      select {
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 14px center;
        padding-right: 36px;
        cursor: pointer;
      }

      textarea {
        resize: vertical;
      }

      .char-count {
        display: block;
        font-size: 12px;
        color: #bbb;
        text-align: right;
        margin-top: 4px;
      }

      &.form-honeypot {
        display: none !important;
      }

      &.form-captcha {
        label { margin-bottom: 6px; }

        .captcha-btn {
          width: 100%;
          padding: 12px 16px;
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          background: $dark;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 6px;

          &:hover:not(:disabled) {
            background: #333;
          }

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }
    }

    .btn-submit {
      width: 100%;
      padding: 14px;
      font-size: 15px;
      font-weight: 600;
      color: #fff;
      background: $gold;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        background: #c4a030;
        transform: translateY(-1px);
        box-shadow: 0 8px 24px rgba(212, 175, 55, 0.3);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .form-msg {
      margin-top: 12px;
      font-size: 13px;
      text-align: center;

      &.success { color: #52c41a; }
      &.error { color: #ff4d4f; }
    }
  }
}

// ===== 响应式 =====
@media (max-width: 1024px) {
  .hero-section .hero-content .hero-title {
    font-size: 60px;
  }

  .about-section .about-grid {
    grid-template-columns: 1fr;
  }

  .services-section .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .advantages-section .advantages-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cert-section .cert-carousel {
    // 保持横向滚动，宽度不变
  }

  .contact-section .contact-wrapper {
    grid-template-columns: 1fr;
  }

  .contact-section .contact-form .form-row {
    flex-wrap: wrap;
    gap: 0;
    margin: 0;
  }

  .contact-section .contact-form .form-group {
    flex: auto;
    padding: 0;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
}

@media (max-width: 768px) {
  .hero-section .hero-content .hero-title {
    font-size: 36px;
  }

  .hero-section .hero-content .hero-actions {
    flex-direction: column;
  }

  .hero-section .hero-content .hero-actions .btn-primary,
  .hero-section .hero-content .hero-actions .btn-outline {
    width: 100%;
    text-align: center;
    justify-content: center;
  }

  .services-section .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .services-section .service-card {
    padding: 32px 24px;

    .service-icon img {
      width: 200px;
      height: 200px;
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 13px;
    }
  }

  .cert-section .cert-carousel {
    // 保持横向滚动
  }

  .about-section .about-content .about-features {
    grid-template-columns: 1fr;
  }

  // ===== 手机端免费评估表单：与 Contact 页 booking-form 完全一致 =====
  .contact-section .contact-form {
    // 姓名和电话输入框各占全宽，和服务类型一样
    .form-row .form-group {
      flex: none;
      width: 100%;
      min-width: 0;
      padding: 0;
    }

    .form-group {
      width: 100%;
      margin-bottom: 16px;

      label {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 6px;
      }

      input, select, textarea {
        width: 100% !important;
        max-width: 100% !important;
        display: block;
        box-sizing: border-box;
        padding: 12px 16px;
        font-size: 15px;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        background: #fff;
        color: #1a1a1a;
        font-family: inherit;
        appearance: none;
        -webkit-appearance: none;

        &::placeholder { color: #bbb; }

        &:focus {
          outline: none;
          border-color: #d4af37;
          box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
        }
      }

      select {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 14px center;
        padding-right: 36px;
        cursor: pointer;
      }

      textarea {
        resize: vertical;
      }

      .char-count {
        display: block;
        font-size: 12px;
        color: #bbb;
        text-align: right;
        margin-top: 4px;
      }
    }

    .form-honeypot { display: none !important; }

    .form-captcha {
      label { margin-bottom: 6px; }

      .captcha-btn {
        width: 100%;
        padding: 12px 16px;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        background: #1a1a1a;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-top: 6px;

        &:hover:not(:disabled) { background: #333; }
        &:disabled { opacity: 0.5; cursor: not-allowed; }
      }
    }

    .btn-submit {
      width: 100%;
      padding: 14px;
      font-size: 15px;
      font-weight: 600;
      color: #fff;
      background: #d4af37;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover:not(:disabled) {
        background: #c4a030;
        transform: translateY(-1px);
        box-shadow: 0 8px 24px rgba(212, 175, 55, 0.3);
      }
      &:disabled { opacity: 0.6; cursor: not-allowed; }
    }

    .form-msg {
      margin-top: 12px;
      font-size: 13px;
      text-align: center;
      &.success { color: #52c41a; }
      &.error { color: #ff4d4f; }
    }
  }
}

</style>
